import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { sendEmailVerification } from 'firebase/auth';
import { FiMail, FiRefreshCw } from 'react-icons/fi';
import './EmailVerificationPage.css';

const EmailVerificationPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [error, setError] = useState(null);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [verificationSent, setVerificationSent] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    if (user.emailVerified) {
      navigate('/onboarding');
    }
  }, [user, navigate]);

  useEffect(() => {
    const checkVerification = setInterval(async () => {
      if (user) {
        await user.reload();
        if (user.emailVerified) {
          navigate('/onboarding');
        }
      }
    }, 3000);

    return () => clearInterval(checkVerification);
  }, [user, navigate]);

  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(() => {
        setResendCooldown(prev => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);

  const handleResendVerification = async () => {
    if (resendCooldown > 0) return;

    try {
      setError(null);
      await sendEmailVerification(user);
      setVerificationSent(true);
      setResendCooldown(60); // 60 seconds cooldown
      
      // Reset verification sent message after 3 seconds
      setTimeout(() => {
        setVerificationSent(false);
      }, 3000);
    } catch (error) {
      console.error('Error sending verification email:', error);
      setError('Failed to send verification email. Please try again.');
    }
  };

  if (!user) return null;

  return (
    <div className="verification-page">
      <div className="verification-card">
        <div className="verification-icon">
          <FiMail size={48} />
        </div>
        
        <h1>Verify Your Email</h1>
        <p className="verification-text">
          We've sent a verification email to <strong>{user.email}</strong>.
          Please check your inbox and click the verification link to continue.
        </p>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        {verificationSent && (
          <div className="success-message">
            Verification email sent successfully!
          </div>
        )}

        <button 
          className="resend-button"
          onClick={handleResendVerification}
          disabled={resendCooldown > 0}
        >
          <FiRefreshCw size={20} />
          {resendCooldown > 0 
            ? `Resend in ${resendCooldown}s` 
            : 'Resend Email'}
        </button>

        <div className="verification-note">
          <p>
            Can't find the email? Check your spam folder or click the resend button above.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationPage; 